export { COMP_INFO } from "./index";

export const LIGHT_LOGO_URL = "/assets/images/logo/light-logo.png";
export const DARK_LOGO_URL = "/assets/images/logo/dark-logo.png";

// roles offered on the login page
export const USER_ROLES = [
  { role_code: 1001, role: "Admin" },
  { role_code: 1003, role: "Supplier" },
];
